import { Winda } from "@brexhq/next/src/utils/Winda";

/**
 * This hook returns either window.location object if it exists or an empty mock
 */
const useLocation = () => {
  if (Winda.isPresent) return window.location;
  return {
    ancestorOrigins: {},
    href: "",
    origin: "",
    protocol: "",
    host: "",
    hostname: "",
    port: "",
    pathname: "",
    search: "",
    hash: "",
  } as Window["location"];
};
export default useLocation;
